import HomePageTransferAssetView from './HomePageTransferAssetView';

export default HomePageTransferAssetView;
